// debug buttons to test audio, text prompt and teleport WS command
import { keys } from '@core/assistant/voiceCommand';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers/MytaverseEventProvider';
import { enableLogging } from '@core/assistant/constants';
import { MytaverseLogger } from '@helpers/logger';
import AssistantQueryService from '@services/AssistantQueryService';
import { AudioVisualizer, visualizeAudio } from './AudioVisualizer';
import { assistantSize } from '@core/assistant/constants';

import { socket } from './Socket';
import {
  SocketEventRequestType,
  SocketEventDirection,
  IDebug,
} from './interfaces';

export const useDebug = (): IDebug => {
  const { sendJSONMessageToWebSocket } = useMytaverse();
  const mytaverseEventProvider = useMytaverseEvent();

  const queryBedrockTest = () => {
    log('queryBedrockTest clicked');
    socket.emit(SocketEventDirection.request, {
      type: SocketEventRequestType.bedrock,
      data: { text: 'What is AWS?' },
    });
  };

  const generateAudioPlaybackTest = async () => {
    log('generateAudioPlaybackTest clicked');

    const pollyResponse = await AssistantQueryService.generateAssistantAudio({
      text: 'This is a test',
      disableOptimizations: true,
    });

    log('polly response', pollyResponse);

    if (pollyResponse.audio) {
      const arrayBuffer = AudioVisualizer.toArrayBuffer(pollyResponse.audio);
      let visualizerInstance: any;

      if (visualizerInstance) {
        visualizerInstance.stopAudio();
      }
      visualizerInstance = visualizeAudio(
        assistantSize.width,
        assistantSize.height,
        () => {},
      );
      visualizerInstance = visualizerInstance.initialize(arrayBuffer);
    } else {
      log('Error: missing Polly audio');
    }
  };

  // simulate N key in GameCast
  function testKeyboard() {
    const enterEvent = new KeyboardEvent('keydown', keys.t);
    // TODO
    /*mytaverseEventProvider.gameCastRef.current.detachInput();
    mytaverseEventProvider.gameCastRef.current.attachInput();
    mytaverseEventProvider.gameCastRef.current.processKeyboardEvent(enterEvent);*/
  }

  function sendWSMessage(message: string) {
    log('sendWSMessage', message);

    const wsMessage = JSON.parse(message);

    log('sendJSONMessageToWebSocket', wsMessage);

    sendJSONMessageToWebSocket(wsMessage);
  }

  return {
    queryBedrockTest,
    generateAudioPlaybackTest,
    testKeyboard,
    sendWSMessage,
  };
};

export const log = (message: string, payload?: any) => {
  if (enableLogging) {
    if (payload) {
      MytaverseLogger.debug(message, payload);
    } else {
      MytaverseLogger.debug(message);
    }
  }
};
